<script setup lang="ts">
import { X } from "lucide-vue-next";
import { Dialog, DialogClose, DialogContent, DialogTitle } from "@/components/ui/dialog";

defineProps<{
  src: string | null;
  alt?: string;
}>();

const open = defineModel<boolean>("open", { default: false });
</script>

<template>
  <Dialog v-model:open="open">
    <DialogContent
      class="w-auto max-w-[90vw] border-0 bg-transparent p-0 shadow-none"
      :show-close-button="false">
      <DialogTitle class="sr-only">{{ alt || "Image" }}</DialogTitle>
      <img
        v-if="src"
        :src="src"
        :alt="alt || ''"
        class="max-h-[85vh] max-w-[90vw] rounded-md object-contain" />
      <DialogClose
        class="absolute -top-3 -right-3 flex h-8 w-8 items-center justify-center rounded-full bg-background text-foreground shadow-md transition-opacity hover:opacity-80">
        <X class="h-4 w-4" />
        <span class="sr-only">Close</span>
      </DialogClose>
    </DialogContent>
  </Dialog>
</template>
